<template>
  <div
    style="width: 100%; height: 100%; cursor: pointer"
    :style="{
      animation: option.attribute.autoRotate
        ? 'rotate ' + option.attribute.rotateDuration + 's infinite linear'
        : null,
    }"
    @click.stop="clickHandler"
  >
    <t-image
      style="width: 100%; height: 100%; z-index: 0"
      :style="{ background: option.attribute.bgColor || 'none' }"
      :src="
        option.attribute.url
          ? fileUrl + option.attribute.url
          : require('@/assets/fullscreen.png')
      "
      :fit="option.attribute.fit"
    />
  </div>
</template>

<script>
import { fileUrl } from "/env";
export default {
  name: "cpt-fullscreen",
  props: {
    option: Object,
  },
  data() {
    return {
      fileUrl,
    };
  },
  methods: {
    clickHandler() {
      console.log("*");
      const element = document.documentElement;
      if (!document.fullscreenElement) {
        element.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    },
  },
};
</script>

<style>
@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}
</style>
